import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DraftIdentifier } from "$src/domain/projects/drafts/DraftIdentifier";
import type { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { NewDraft } from "$src/domain/projects/drafts/NewDraft";
import { inject, injectable } from "tsyringe";

@injectable()
export class OverrideDraft {
    
    constructor(@inject(ServiceTokens.ProjectDraftRepository) private projectDraftRepository: IProjectDraftRepository) {}

    async execute(groupStoreId: number, projectId: number, newDraft: NewDraft): Promise<DraftIdentifier> {

        return await this.projectDraftRepository.OverrideDraft(groupStoreId, projectId, newDraft);
    }
}

export const OverrideDraftToken = Symbol('OverrideDraftToken');